import React from 'react';
import { FormattedMessage } from 'react-intl';

const Translate = (props: {
  id: string;
  fallback?: string;
  values?: any;
  children?: (msg: string) => JSX.Element;
}): JSX.Element => {
  const { id, fallback, values, children } = props;
  return (
    <FormattedMessage id={id} defaultMessage={fallback || id} values={values}>
      {children}
    </FormattedMessage>
  );
};

export default Translate;
